__turbopack_context__.v({
  "badge": "Badge-module__9PBjjq__badge",
  "badgeDefault": "Badge-module__9PBjjq__badgeDefault",
  "badgeError": "Badge-module__9PBjjq__badgeError",
  "badgeInfo": "Badge-module__9PBjjq__badgeInfo",
  "badgePrimary": "Badge-module__9PBjjq__badgePrimary",
  "badgeSecondary": "Badge-module__9PBjjq__badgeSecondary",
  "badgeSuccess": "Badge-module__9PBjjq__badgeSuccess",
  "badgeWarning": "Badge-module__9PBjjq__badgeWarning",
  "sizeMedium": "Badge-module__9PBjjq__sizeMedium",
  "sizeSmall": "Badge-module__9PBjjq__sizeSmall",
});
